var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('v-overlay',{attrs:{"value":_vm.loading,"z-index":"205"}},[_c('v-progress-circular',{attrs:{"color":"#01579B","indeterminate":"","size":"90","width":"7"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }